import Styles from './Layout.module.scss';

const ContentArea = ({ children }) => {
  return <div className={Styles.contentArea}>{children}</div>;
};

export default ContentArea;
